import React, { useContext, useRef } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { Alert } from '../../components/alert'
import { ContextShell } from '../../modules/context'
import styles from './toast-container.module.scss'

export const ToastContainer: React.FC = () => {
  const nodeRefs = useRef(
    new Map<string, React.RefObject<HTMLLIElement | null>>()
  )
  const { toast } = useContext(ContextShell)

  return (
    <ul className={styles.list}>
      <TransitionGroup>
        {toast.list.map((alert: any) => {
          if (!nodeRefs.current.has(alert.id)) {
            nodeRefs.current.set(alert.id, React.createRef<HTMLLIElement>())
          }

          const nodeRef = nodeRefs.current.get(alert.id)

          return (
            <CSSTransition
              key={alert.id}
              timeout={500}
              classNames="alert-toast"
              nodeRef={nodeRef as React.RefObject<HTMLLIElement>}
            >
              <li className={styles.item}>
                <Alert {...alert} />
              </li>
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </ul>
  )
}
